var render = function render(){var _vm=this,_c=_vm._self._c;return _c('computed-line-chart',{class:_vm.folded ? 'folded-chart-cover' : '',style:(_vm.heightStyle),attrs:{"node-ids":_vm.nodeIdList}},[_c('div',{attrs:{"id":"lineChart"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }